import ZFIcon from "../ui-component/ZFIcon/ZFIcon";
import { ITileProps, TOperator } from "./SummaryCard.fixtures";
import { Tile } from "./Tile";
import { TIconType } from "../component";

const TileWithOperator = (props: ITileProps) => {
	return (
		<>
			<div
				className={`${
					props.column.sign ? "mobile-view-18 operator-padding" : ""
				}`}
			>
				{props.column.sign && <Operator operator={props.column.sign} />}
			</div>

			<div className={Boolean(props.column.sign) ? "mobile-view-80" : ""}>
				<Tile
					key={props.key}
					column={props.column}
					data={props.data}
					dynamicallyComparedKey={props.dynamicallyComparedKey}
					timeMode={props.timeMode}
				/>
			</div>
		</>
	);
};

export default TileWithOperator;

interface IOperatorProps {
	operator: TOperator;
}

const Operator = (props: IOperatorProps) => {
	const getIconNameByOperator = (operator: TOperator): TIconType => {
		switch (operator) {
			case "ADDITION":
				return "add";
			case "SUBSTRACTION":
				return "minus";
			case "EQUAL_TO":
				return "equal";
			default:
				return null;
		}
	};
	return <ZFIcon iconName={getIconNameByOperator(props.operator)} />;
};
